import React from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../../contexts/LanguageContext";
import { V2, pickLang } from "../copy";
import { route } from "../paths";

const SOCIAL: [string, string][] = [
  ["TikTok", "https://www.tiktok.com/@lavetesbaskets"],
  ["Instagram", "https://www.instagram.com/lave_tes_baskets/"],
  ["Snapchat", "https://www.snapchat.com/@lavetesbaskets"],
  ["X", "https://x.com/lavetesbaskets"],
];

const FooterV2: React.FC = () => {
  const { currentLanguage, changeLanguage } = useLanguage();
  const lang = pickLang(currentLanguage);
  const c = V2[lang].footer;
  const other = lang === "fr" ? "en" : "fr";

  const Col: React.FC<{ title: string; children: React.ReactNode }> = ({ title, children }) => (
    <div>
      <div className="font-mono text-[11px] uppercase tracking-[0.22em] text-bone/40">{title}</div>
      <ul className="mt-4 space-y-2.5 text-sm">{children}</ul>
    </div>
  );

  return (
    <footer className="bg-ink text-bone">
      <div className="v2-rule" aria-hidden />
      <div className="mx-auto max-w-[1400px] px-4 pt-16 sm:px-6">
        <div className="grid grid-cols-2 gap-x-6 gap-y-10 lg:grid-cols-12">
          <div className="col-span-2 lg:col-span-5">
            <img
              src="/lavetesbasket_logow.png"
              alt="Lave Tes Baskets"
              className="h-14 w-auto object-contain"
            />
            <p className="mt-4 max-w-xs text-sm text-bone/55">
              {lang === "fr"
                ? "Atelier de nettoyage et de soin pour sneakers, en Île-de-France. Collecte, nettoyage expert, retour."
                : "Sneaker cleaning and care atelier in Île-de-France. Pickup, expert cleaning, return."}
            </p>
          </div>
          <div className="col-span-2 sm:col-span-1 lg:col-span-3">
            <Col title={c.discover}>
              {c.links.map(([path, label]) => (
                <li key={path}>
                  <Link to={route(lang, path)} className="v2-link text-bone/80">
                    {label}
                  </Link>
                </li>
              ))}
            </Col>
          </div>
          <div className="lg:col-span-2">
            <Col title={c.follow}>
              {SOCIAL.map(([label, href]) => (
                <li key={label}>
                  <a href={href} target="_blank" rel="noopener noreferrer" className="v2-link text-bone/80">
                    {label}
                  </a>
                </li>
              ))}
            </Col>
          </div>
          <div className="lg:col-span-2">
            <Col title={c.legal}>
              {c.legalLinks.map(([path, label]) => (
                <li key={path}>
                  <Link to={`/${lang}/${path}`} className="v2-link text-bone/80">
                    {label}
                  </Link>
                </li>
              ))}
            </Col>
          </div>
        </div>

        {/* giant outlined wordmark */}
        <div className="mt-16 overflow-hidden">
          <div
            className="v2-outline select-none whitespace-nowrap font-display text-[clamp(3rem,12.4vw,13.5rem)] leading-[0.85] tracking-[-0.04em]"
            aria-hidden
          >
            LAVE TES BASKETS
          </div>
        </div>

        <div className="v2-hair flex flex-wrap items-center justify-between gap-4 border-t py-6 font-mono text-[10px] uppercase tracking-[0.2em] text-bone/40">
          <span>
            {`© ${new Date().getFullYear()} Lave Tes Baskets · ${c.rights}`}
          </span>
          <div className="flex items-center gap-6">
            <button onClick={() => changeLanguage(other)} className="v2-link uppercase hover:text-bone">
              {other}
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterV2;
